import { apiPath } from '../../constants';
import { addSuccessMessage } from 'actions';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const SPORTSMEN_POST_REQUEST = 'POST_SPORTSMEN_REQUEST';
export const SPORTSMEN_POST_FAILURE = 'POST_SPORTSMEN_FAILURE';
export const SPORTSMEN_POST_SUCCESS = 'POST_SPORTSMEN_SUCCESS';

export const postSportsman = (data) => {
    return function(dispatch) {
        dispatch(postSportsmanRequest());
        return axios(apiRequestOptions(apiPath.SPORTSMEN.POST, data))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(postSportsmanSuccess(response.data));
                dispatch(addSuccessMessage('Sportsman successfully added'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postSportsmanFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postSportsmanRequest = () => ({type: SPORTSMEN_POST_REQUEST});
const postSportsmanFailure = error => ({type: SPORTSMEN_POST_FAILURE, error})
const postSportsmanSuccess = sportsman => ({type: SPORTSMEN_POST_SUCCESS, sportsman})
